<template>
  <validation-observer ref="formRef" novalidate tag="form">
    <div class="px-3 pt-3">
      <div class="d-flex align-items-center mb-3 pt-2">
        <img
          alt=""
          class="mr-2"
          src="@/assets/img/file-plus-circle.svg"
          style="width: 20px; height: 20px"
        />
        <span class="color-black font-18 font-weight-bold">
          Registrar Pago
        </span>
      </div>
      <div class="row">
        <div class="col-12 col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              id="paymentReferenceNumber"
              v-model="form.paymentReferenceNumber"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              label="Número de Referencia de Pago:"
              placeholder="Ingrese número de referencia"
            />
          </validation-provider>
        </div>
        <div class="col-12 col-md-4 mt-3 mt-md-0">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              id="paymentDate"
              v-model="form.paymentDate"
              class-container="w-100"
              custom-error-msg="El campo es requerido"
              :error="errors[0]"
              label="Fecha de Pago:"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-3 pb-3">
        <div class="col-12 d-flex justify-content-end">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger px-3 mr-2"
            @click="onCancel"
          >
            Cancelar
          </action-button>
          <action-button i="fas fa-save" variant="success px-3" @click="onSave">
            Guardar
          </action-button>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';

export default {
  name: 'AddPaymentReference',
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomDatePicker,
    ActionButton,
  },
  data() {
    return {
      form: {
        paymentReferenceNumber: null,
        paymentDate: null,
      },
    };
  },
  methods: {
    async onSave() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) return;
      this.$emit('on-save', { ...this.form });
    },
    onCancel() {
      this.$refs.formRef.reset();
      this.form = { paymentReferenceNumber: null, paymentDate: null };
      this.$emit('on-cancel');
    },
  },
};
</script>
